$(function () {
	const $template = $('#services-popup');

	function createPopUp(data, index, items) {
		var link = $template.find('#services-popup-link');
		var contactsTitle = $template.find('.b-services-popup__contacts-title');

		$template
			.find('#services-popup-category').text(data.OWNER).end()
			.find('#services-popup-name').html(data.NAME).end()
			.find('#services-popup-description').html(data.DESCRIPTION).end()
			.find('#services-popup-link').text(data.LINK).attr('href', data.LINK).end().show()
			.find('#services-popup-additional').html(data.ADDITIONAL).end()
			.find('#services-popup-contacts').html(data.CONTACTS);

		//hide or show by condition
		data.LINK ? link.show() : link.hide();
		data.CONTACTS ? contactsTitle.show() : contactsTitle.hide();

		if (items.length === 1) {
			$template.find('.b-services-popup__arrows').hide();
		} else {
			$template.find('.b-services-popup__arrows').show();
		}

		const nextText = index + 1 >=items.length ? items[0] : items[index + 1];

		$template.find('#services-popup-next').text(
			nextText.NAME
		);

		return {
			src: $template[0].outerHTML,
			type: 'html'
		}
	}

	function modalOpen(e) {

		let $target = e?$(e.currentTarget):$('[data-index='+window.location.hash.replace('#','')+']');

		let currentId = e?$target.data('index'):window.location.hash.replace('#','');

		if (!currentId) {
			return;
		}

		const idMap = [
			currentId,
			...$target.siblings().toArray().map(el => $(el).data('index')),
		];

		let popUps = []

		if (window.servicesList && Array.isArray(window.servicesList)) {
			popUps = idMap.map(id => window.servicesList[id])
				.map(createPopUp);
		}

		$.fancybox.open(popUps, {
			arrows: false,
			closeExisting: true,
			animationEffect: 'slide',
			transitionEffect: 'slide',
			animationDuration: 400,
			touch: false,
			loop: true,
		});
	}

	$(document).on('click', '.b-services-list-card__item', modalOpen);
	if(window.location.hash) {
		modalOpen();
	}
});

